import React from 'react'
import Logo from "./Logo_blanco.png"

const LogoV2 = ({ width, height }) => {
  return (
    <img src={Logo} alt="Logo" width={width} height={height} />
  )
}

export default LogoV2